module.exports = __webpack_public_path__ + "static/img/9.a50c7a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/9.png
// module id = uRnR
// module chunks = 0